export const UploadCircleIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.4"
      d="M9 17.0625C4.5472 17.0625 0.9375 13.4528 0.9375 9C0.9375 4.5472 4.5472 0.9375 9 0.9375C13.4528 0.9375 17.0625 4.5472 17.0625 9C17.0625 13.4528 13.4528 17.0625 9 17.0625Z"
      fill="#111827"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.75 12.75C9.75 13.1642 9.41421 13.5 9 13.5C8.58579 13.5 8.25 13.1642 8.25 12.75V10.4037H7.83746L7.82308 10.4037C7.7689 10.4039 7.66078 10.4043 7.56515 10.3905C7.47929 10.3782 7.09314 10.3149 6.91485 9.91381C6.73656 9.5127 6.94834 9.18367 6.9967 9.11167C7.05057 9.03147 7.12327 8.95144 7.1597 8.91134L7.16936 8.90068L7.67319 8.34248C7.83821 8.15954 8.00887 7.97034 8.17133 7.83302C8.35558 7.67727 8.62886 7.5 9 7.5C9.37114 7.5 9.64441 7.67727 9.82867 7.83302C9.99113 7.97034 10.1618 8.15953 10.3268 8.34247L10.8306 8.90068L10.8403 8.91133C10.8767 8.95143 10.9494 9.03146 11.0033 9.11167C11.0517 9.18367 11.2634 9.5127 11.0851 9.91381C10.9069 10.3149 10.5207 10.3782 10.4349 10.3905C10.3392 10.4043 10.2311 10.4039 10.1769 10.4037L10.1625 10.4037H9.75V12.75ZM6.75 6C6.33579 6 6 5.66421 6 5.25C6 4.83579 6.33579 4.5 6.75 4.5H11.25C11.6642 4.5 12 4.83579 12 5.25C12 5.66421 11.6642 6 11.25 6H6.75Z"
      fill="white"
    />
  </svg>
);
